import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { showModal } from "../../../features/modal/modalSlice"
import { useEffect } from "react"
import { useScrollLock } from "../../../hooks/useScrollLock"
import styled from "styled-components"
import PageTopTitle from "../../shared/PageTopTitle"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import { changeStatusSubUser } from "../../../features/companyProfile/companyAuthorizationSlice"


const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: auto;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            padding: 40px 0;
            width: 500px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 20px;
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin: 30px 0;
            gap: 50px;
        }
    }
`

const ProfilAltKullaniciOptionsModal = () => {
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const {selectedUser } = useSelector(state => state.companyAuthorization)
    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])
    
  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal" onClick={(e) => {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <PageTopTitle title={"Kullanıcı Ayarları"}/>
        <div className="content">
            <Btn bgColor={"#fff"} color={"#E85446"} width="280px" handleClick={() => dispatch(showModal("kullaniciRolYetkiUpdate"))}>Yetkiler</Btn>
            <Btn bgColor={"#fff"} color={"#E85446"} width="280px" handleClick={() => dispatch(changeStatusSubUser({userId: selectedUser?.id}))}>{selectedUser?.isActive ? "Hesabı Aktif Et" : "Hesabı Pasife Al"}</Btn>
            <Btn bgColor={"#E85446"} color={"#fff"} width="280px" handleClick={() => dispatch(showModal(null))}>Kapat</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default ProfilAltKullaniciOptionsModal